module.exports = __webpack_public_path__ + "5894362e9b6417ca6858f073e7f05203.png";